import React from "react";

const AboutUsBtn = ({ icon, title }) => {
  return (
    <button className="flex justify-between  rounded-md hover:bg-designColor hover:text-primeColor font-semibold duration-300 cursor-pointer items-center px-6 gap-2 py-4 bg-primeColor text-white text-base">
      {title} <span>{icon}</span>
    </button>
  );
};

export default AboutUsBtn;
